import { Link, Typography } from "@mui/material";
import useOrderData from "components/Orders/useOrderData";
import useQuoteData from "components/Quotes/useQuoteData";
import useCurrencyFormatter from "helpers/hooks/useCurrencyFormatter";

import { ILineItem } from "models/IQuote";
import { useMemo } from "react";

interface IProps {
    lineItem: ILineItem,
    variant: any,
    showQuantity: boolean,
    showSqFtPrice: boolean,
    onQtyClick?: (lineItem: ILineItem) => void,
    onPriceClick?: (lineItem: ILineItem) => void,
    isOrder: boolean;
}

const LineItemUnitPrice: React.FC<IProps> = ({ lineItem, variant, showQuantity, showSqFtPrice, onQtyClick, onPriceClick, isOrder }: IProps) => {

    const { quote } = useQuoteData();
    const { order } = useOrderData();

    const currencyFormatter = useCurrencyFormatter(isOrder ? order?.currencyCulture : quote?.currencyCulture);

    const getPriceText = (lineItem: ILineItem): string => {
        return currencyFormatter.Format(lineItem.unitPrice);
    }

    const getSqFtPriceText = (lineItem: ILineItem): string => {
        return currencyFormatter.Format(lineItem.sqFtPrice);
    }

    const isPriceBold = useMemo(() => {
        return lineItem.priceOverride;
    }, [lineItem]);

    return <>
        {showQuantity && onQtyClick &&
            <Link component="button" underline="hover" onClick={(event: React.SyntheticEvent) => { event.preventDefault(); onQtyClick(lineItem); }}
                variant={variant} sx={{ mr: 1 }} >
                {`${lineItem.quantity} x`}
            </Link>
        }
        {showQuantity && !onQtyClick &&
            <Typography variant={variant} mr={1}>
                {`${lineItem.quantity} x`}
            </Typography>
        }
        {showSqFtPrice ?
            <Typography variant={variant} fontWeight={isPriceBold ? "bold" : ""} >
                {getSqFtPriceText(lineItem)}
            </Typography>
            :
            (
                onPriceClick ?
                    <Link component="button" underline="hover" onClick={(event: React.SyntheticEvent) => { event.preventDefault(); onPriceClick(lineItem); }}
                        variant={variant} textAlign="right" fontWeight={isPriceBold ? "bold" : ""} >
                        {getPriceText(lineItem)}
                    </Link>
                    :
                    <Typography variant={variant} fontWeight={isPriceBold ? "bold" : ""} >
                        {getPriceText(lineItem)}
                    </Typography>
            )

        }
    </>;

};

export default LineItemUnitPrice;